import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 35223,
  clicks: 698,
  adsSpendDollars: 1881,
  budgetDollars: 1900,
  salesDollars: 8978,
  bestEstimateRoas: 4.77,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.99,
  newCustomersAcquired: 16,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
